<div class="container-fluid animated fadeIn fast">
  <form (ngSubmit)="search()" #filterForm="ngForm">
    <div class="row mt-3 animated fadeIn fadeOut" [hidden]="newData || newPatients || newPatientsData">
      <div class="col-lg-6">
        <mat-card [class.disabled]="filter.hasPatient()">
          <mat-card-title>
            Solicitud
          </mat-card-title>
          <mat-card-content>
            <div class="row">
              <mat-form-field class="col-md-6">
                <mat-label>N° Protocolo</mat-label>
                <input matInput placeholder="" [(ngModel)]="filter.orderId" name="orderid"
                  [disabled]="filter.hasPatient()">
              </mat-form-field>
              <mat-form-field class="col-md-6">
                <mat-label>Servicio</mat-label>
                <mat-select multiple #selectWard [(ngModel)]="filter.wards" name="ward" [disabled]="filter.hasPatient() || filter.hasProtocol"
                (selectionChange)="wardChanged()">                 
                  <div class="select-all">
                  <mat-checkbox [(ngModel)]="allSelectedWard"
                        [ngModelOptions]="{standalone: true}"
                        (change)="toggleAllWardSelection(selectWard)">Todos</mat-checkbox>
                  </div>
                  <mat-option *ngFor="let ward of wards" [value]="ward">
                    {{ward.wardDescription}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="row">
              <mat-form-field class="col-md-3">
                <mat-label *ngIf="!(filter.hasPatient() || filter.hasProtocol)">Desde</mat-label>
                <input matInput (focus)="picker.open()" [min]="minDate" [max]="maxDate" [matDatepicker]="picker"
                  name="startDate" [(ngModel)]="filter.startDate" [disabled]="filter.hasPatient() || filter.hasProtocol">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="col-md-3">
                <mat-label *ngIf="!(filter.hasPatient() || filter.hasProtocol)">Hasta</mat-label>
                <input matInput (focus)="picker2.open()" [min]="minDate" [max]="maxDate" [matDatepicker]="picker2"
                  name="endDate" [(ngModel)]="filter.endDate" [disabled]="filter.hasPatient() || filter.hasProtocol">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="col-md-6">
                <mat-label>Estado</mat-label>
                <mat-select multiple #selectState [(ngModel)]="filter.orderState" name="state" [disabled]="filter.hasPatient() || filter.hasProtocol"
                (selectionChange)="stateChanged()">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="allSelectedState"
                          [ngModelOptions]="{standalone: true}"
                          (change)="toggleAllStateSelection(selectState)">Todos</mat-checkbox>
                    </div>
                  <mat-option *ngFor="let state of filter.state_list" [value]="state.value">
                    {{state.description}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>


          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-lg-6">
        <mat-card [class.disabled]="filter.hasOrder(allSelectedWard, allSelectedState)">
          <mat-card-title>
            Paciente
          </mat-card-title>
          <mat-card-content>
            <div class="form-row">
              <mat-form-field class="col-md-6">
                <mat-label>Nombre</mat-label>
                <input matInput placeholder="" [(ngModel)]="filter.name" name="name" [disabled]="filter.hasOrder(allSelectedWard, allSelectedState)">
              </mat-form-field>
              <mat-form-field class="col-md-6">
                <mat-label>Apellido</mat-label>
                <input matInput placeholder="" [(ngModel)]="filter.surname" name="surname"
                  [disabled]="filter.hasOrder(allSelectedWard, allSelectedState)">
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="col-md-6">
                <mat-label>DNI</mat-label>
                <input matInput placeholder="" [(ngModel)]="filter.dni" name="dni" [disabled]="filter.hasOrder(allSelectedWard, allSelectedState)">
              </mat-form-field>
              <mat-form-field class="col-md-6">
                <mat-label>{{env.hc_label}}</mat-label>
                <input matInput placeholder="" [(ngModel)]="filter.hc" name="hc" [disabled]="filter.hasOrder(allSelectedWard, allSelectedState)">
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>

      </div>

    </div>

    <div class="col-lg-12 text-center mt-3 mb-3 animated fadeIn fadeOut"
      [hidden]="newData || newPatients|| newPatientsData">
      <button mat-raised-button color="primary" type="submit" [disabled]="!filter.isValid()"> Buscar </button>
      <button mat-raised-button (click)="clean();$event.preventDefault()"> Limpiar </button>
    </div>

  </form>


  <div class="col-lg-12  animated fadeIn fadeOut" [hidden]="!(newData || newPatientsData)">
    <div class="row mt-3">
      <button mat-raised-button class="mr-2" (click)="clean()"> Nueva búsqueda </button>
      <button mat-raised-button *ngIf="newPatientsData && patientSource.data.length>1" color="primary"
        (click)="viewPatientList();"> Volver al listado
      </button>
      <div class="spacer"></div>
      <button mat-raised-button color="primary" (click)="viewReports()" [disabled]="orderSelection.selected.length == 0"
        matTooltip="Visualizar informes">
        Ver informes
      </button>
    </div>
  </div>

  <mat-card [hidden]="!newData" class="mt-3 animated fadeIn fadeOut">
    <mat-card-title>
      Solicitudes
    </mat-card-title>
    <mat-card-content>
      <mat-paginator #orderPaginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
      <table mat-table [dataSource]="dataSource" matSort class="w-100">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox #masterToggleEl="matCheckbox" (change)="$event ? orderMasterToggle(masterToggleEl) : null"
              [checked]="orderSelection.hasValue() && isAllOrderSelected()"
              [indeterminate]="orderSelection.hasValue() && !isAllOrderSelected()" [aria-label]="checkboxOrderLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? orderSelection.toggle(row) : null"
              [checked]="orderSelection.isSelected(row)" [aria-label]="checkboxOrderLabel(row)"
              [disabled]="row.reportState == 0">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Number Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Protocolo</th>
          <td mat-cell></td>
          <td mat-cell *matCellDef="let order">
            <span class="order-badge" [class.urgent-badge]="order.priorityLevel == 3">
              {{ order.orderId }}
            </span>
          </td>
        </ng-container>

        <!-- alert column -->
        <ng-container matColumnDef="warning">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell></td>
          <td mat-cell *matCellDef="let order">
            <mat-icon *ngIf="order.ysnCriticalAlarm == -1" aria-hidden="false" class="alert-icon"
              aria-label="alert icon" matTooltip="Resultados fuera de los valores de referencia">error_outline
            </mat-icon>
          </td>
        </ng-container>

        <!-- Title Column -->
        <ng-container matColumnDef="orderDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha</th>
          <td mat-cell></td>
          <td mat-cell *matCellDef="let order">{{order.orderDate}}</td>
        </ng-container>

        <!-- DOCTOR Column -->
        <ng-container matColumnDef="doctor">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell></td>
          <td mat-cell *matCellDef="let order">

            <mat-icon *ngIf="order.doctorNameSurname != null" class="doctor-icon ml-3" svgIcon="doctor"
              [matTooltip]="order.doctorNameSurname"></mat-icon>
          </td>
          <!--+" "+(order.patientSex =="F" ? "♀":"♂") }}-->
        </ng-container>

        <!-- State Column -->
        <ng-container matColumnDef="patientName">
          <th mat-header-cell *matHeaderCellDef>
            <div class="table-filter">
              <mat-form-field>
                <mat-label class="filter-form-field">Paciente</mat-label>
                <input matInput type="text" [formControl]="patientFilter">
              </mat-form-field>
              <!--
                    -->
            </div>
          </th>
          <td mat-cell></td>
          <td mat-cell *matCellDef="let order">
            <button mat-icon-button *ngIf="group.patientHistoric"
              (click)="searchPatientHistory({id: order.patientId}); $event.stopPropagation()">
              <mat-icon matTooltip="Historial del paciente" aria-hidden="false" aria-label="history"
                class="history-icon" svgIcon="history">
                </mat-icon>
            </button>
            <span [matMenuTriggerFor]="patientInfo" (click)="$event.stopPropagation()">{{ order.patientName }}</span> 

            <mat-menu #patientInfo="matMenu">
              <span class="mat-info" *ngIf="order.patientFiscalCode">
                DNI: <span class="bold">{{order.patientFiscalCode}}</span> <br />
              </span>
              <span class="mat-info" *ngIf="order.patientHealthCode">
                {{env.hc_label}}: <span class="bold">{{order.patientHealthCode}}</span> <br />
              </span>
              <span class="mat-info" *ngIf="order.patientAddress">
                Dirección: <span class="bold">{{order.patientAddress}}</span> <br />
              </span>
              <span class="mat-info" *ngIf="order.patientPhone">
                Teléfono: <span class="bold">{{order.patientPhone}}</span> <br />
              </span>

              <span class="mat-info" *ngIf="order.patientMail">
                E-mail: <span class="bold">{{order.patientMail}}</span> <br />
              </span>
            </mat-menu>
          </td>
        </ng-container>

        

        <!-- State Column -->
        <ng-container matColumnDef="sex">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell></td>
          <td mat-cell *matCellDef="let order">
            <span [matTooltip]="order.patientBirthdate">{{order.patientAge}}</span><span
              [class.icon-male]="order.patientSex =='M'" [class.icon-female]="order.patientSex =='F'"
              [class.icon-neutral]="order.patientSex !='F' && order.patientSex !='M'"></span>
          </td>
          <!--+" "+(order.patientSex =="F" ? "♀":"♂") }}-->
        </ng-container>

        <!-- Ward Column -->
        <ng-container matColumnDef="service">
          <th mat-header-cell *matHeaderCellDef class="ward">
            <span *ngIf="filterService==1">Servicio</span>
            <div class="table-filter" *ngIf="filterService!=1">
              <mat-form-field>
                <mat-label class="filter-form-field">Servicio</mat-label>
                <mat-select [formControl]="serviceFilter">
                  <mat-option [value]="''">
                    Todos
                  </mat-option>
                  <mat-option *ngFor="let service of filterService" [value]="service">
                    {{service}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!--
                  <mat-form-field>
                    <input matInput class="form-field" [formControl]="serviceFilter" placeholder="Servicio">
                  </mat-form-field>  -->
            </div>
          </th>
          <td mat-cell *matCellDef="let order">{{ order.service }}


          </td>
        </ng-container>

        <!-- State Column -->
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef>
            <span *ngIf="filterState==1">Estado</span>
            <div class="table-filter" *ngIf="filterState!=1">
              <mat-form-field>
                <mat-label class="filter-form-field">Estado</mat-label>
                <mat-select [formControl]="stateFilter">
                  <mat-option [value]="''">
                    Todos
                  </mat-option>
                  <mat-option *ngFor="let state of filterState" [value]="state">
                    {{state}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">{{ order.state }}</td>
        </ng-container>


        <!-- ACtions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button [class.filter-reports]="withReports" (click)="filterWithReport()"
              [disabled]="!orderWithReports">
              <mat-icon aria-hidden="false" aria-label="report icon">description</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="setFilters()">
              <span class="icon-erase"></span>
            </button>
          </th>
          <td mat-cell *matCellDef="let order">
            <button mat-icon-button *ngIf="group.gridResult"
              (click)="viewResults(order); $event.stopPropagation()">
              <mat-icon aria-hidden="false" aria-label="view results icon">view_list</mat-icon>
            </button>
            <button mat-icon-button (click)="viewReport(order); $event.stopPropagation()"
              [color]="order.reportState >= 2 ? env.color_report_complete:env.color_report_partial" [disabled]="order.reportState == 0"
              [matTooltip]="order.reportState >= 2 ? 'Informe final':'Informe parcial'">
              <mat-icon aria-hidden="false" aria-label="print icon">description</mat-icon>
            </button>
            <button mat-icon-button (click)="viewInfo(order); $event.stopPropagation()">
              <mat-icon aria-hidden="false" aria-label="view info icon">info</mat-icon>
            </button>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let order; columns: displayedColumns;" (click)="selectOrder(order)"></tr>
      </table>
    </mat-card-content>
  </mat-card>



  <!------ LISTA DE PACIENTES ------>
  <mat-card class="mt-3 fadeIn fadeOut" [hidden]="!newPatients || newPatientsData">
    <mat-card-title>
      Pacientes
    </mat-card-title>
    <mat-card-content>
      <mat-paginator #patientPaginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>

      <table mat-table [dataSource]="patientSource" matSort #patientSort="matSort" class="w-100">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row):null"
              [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Number Column -->
        <ng-container matColumnDef="fiscalCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>DNI</th>
          <td mat-cell *matCellDef="let patient">{{ patient.fiscalCode }}</td>
        </ng-container>

        <ng-container matColumnDef="healthCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{env.hc_label}}</th>
          <td mat-cell *matCellDef="let patient">{{ patient.healthCode }}</td>
        </ng-container>

        <!-- Title Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
          <td mat-cell *matCellDef="let patient">{{patient.name}}
          </td>
        </ng-container>

        <ng-container matColumnDef="surname">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Apellido</th>
          <td mat-cell *matCellDef="let patient">{{patient.surname}}
          </td>
        </ng-container>

        <!-- AGE -->

        <!-- GENDER -->
        <ng-container matColumnDef="sex">
          <th mat-header-cell *matHeaderCellDef>Sexo</th>
          <td mat-cell *matCellDef="let patient">
            <span [class.icon-male]="patient.sex =='M'" [class.icon-female]="patient.sex =='F'"
              [class.icon-neutral]="patient.sex !='F' && patient.sex !='M'"></span>
          </td>
        </ng-container>

        <!-- State Column -->
        <ng-container matColumnDef="birthdate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de nacimiento</th>
          <td mat-cell *matCellDef="let patient">{{ patient.birthdate }}</td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="patientColumns"></tr>
        <tr mat-row *matRowDef="let patient; columns: patientColumns;" (click)="selectPatient(patient, patient.index)"
          [class.selected]="patient.selected"></tr>
      </table>

      <div class="mt-3 text-center">
        <button mat-raised-button (click)="clean()"> Cancelar </button>
        <button mat-raised-button color="primary" (click)="searchPatientsOrders()"
          [disabled]="!patientSelected">Seleccionar</button>
      </div>

    </mat-card-content>
  </mat-card>


  <!-- PATIENTS ORDERS -->
  <div class="row mt-3 mb-3 fadeIn " [hidden]="!newPatientsData">
    <div class="col-lg-12">

      <mat-accordion class="patients-accordion">
        <mat-expansion-panel *ngFor="let patient of patients; let i = index;" (opened)="showPatientOrders(patient, i)"
          (closed)="clearPatientOrders(); selectedRow = -1" [expanded]="onePatient" hideToggle
          (afterExpand)="openedPatient(i)" [class.not-expanded]="selectedRow != i && selectedRow != -1">
          <mat-expansion-panel-header>
            <mat-panel-description>

              <span class="name bold">{{patient.nameSurname + " "}} </span>

              <span class="sex info w-20 text-left" [class.icon-male]="patient.sex =='M'"
                [class.icon-female]="patient.sex =='F'"
                [class.icon-neutral]="patient.sex !='F' && patient.sex !='M'"></span>

              <span class="birthdate info  w-20 text-left">
                <span *ngIf="patient.age" [matTooltip]="patient.birthdate">Edad: <span
                    class="bold">{{patient.age}}</span></span>
              </span>

              <span class="fiscalcode info  w-20 text-left">
                <span *ngIf="patient.fiscalCode"> DNI: <span class="bold">{{patient.fiscalCode}}</span></span>
              </span>

              <span class="healthCode info  w-20 text-left">
                <span *ngIf="patient.healthCode"> {{env.hc_label}}: <span class="bold">{{patient.healthCode}}</span></span>
              </span>

              <span class="actions">
                <button mat-icon-button [disabled]="selectedRow != i && selectedRow != -1"
                  (click)="viewPatientsReports(patient); $event.stopPropagation()">
                  <mat-icon matTooltip="Ver todos los informes" aria-hidden="false" aria-label="print icon">description
                  </mat-icon>
                </button>

                <button mat-icon-button [disabled]="selectedRow != i && selectedRow != -1" [matMenuTriggerFor]="menu"
                  (click)=" $event.stopPropagation()">
                  <mat-icon matTooltip="Más información" aria-hidden="false" aria-label="history">info</mat-icon>
                </button>

                <button mat-icon-button [disabled]="selectedRow != i && selectedRow != -1"
                  (click)="searchPatientHistory(patient); $event.stopPropagation()">
                  <mat-icon *ngIf="group.patientHistoric" matTooltip="Historial del paciente" aria-hidden="false"
                    aria-label="history" class="history-icon" svgIcon="history">
                  </mat-icon>
                </button>


              </span>
              <mat-menu #menu="matMenu">
                <span class="mat-info" *ngIf="patient.phone">
                  Teléfono: <span class="bold">{{patient.phone}}</span> <br />
                </span>
                <span class="mat-info" *ngIf="patient.email">
                  E-mail: <span class="bold">{{patient.email}}</span> <br />
                </span>
                <span class="mat-info" *ngIf="!(patient.email && patient.phone)">
                  Sin info
                </span>
              </mat-menu>
            </mat-panel-description>
          </mat-expansion-panel-header>


          <mat-progress-spinner *ngIf="status==0" color="primary" mode="indeterminate" value="10">
          </mat-progress-spinner>
          <span *ngIf="status == 0"> Cargando</span>

          <span *ngIf="status == 2"> Sin solicitudes</span>
          <table mat-table [hidden]="status != 1" [dataSource]="dataSource" matSort #patientOrdersSort="matSort" class="w-100">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox #masterToggleEl="matCheckbox" (change)="$event ? orderMasterToggle(masterToggleEl) : null"
                  [checked]="orderSelection.hasValue() && isAllOrderSelected()"
                  [indeterminate]="orderSelection.hasValue() && !isAllOrderSelected()"
                  [aria-label]="checkboxOrderLabel()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? orderSelection.toggle(row) : null"
                  [checked]="orderSelection.isSelected(row)" [aria-label]="checkboxOrderLabel(row)"
                  [disabled]="row.reportState == 0">
                </mat-checkbox>
              </td>
            </ng-container>

            <!-- Number Column -->
            <ng-container matColumnDef="orderId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Protocolo</th>
              <td mat-cell *matCellDef="let order">
                <span class="order-badge" [class.urgent-badge]="order.priorityLevel == 3">
                  {{ order.orderId }}
                </span>
              </td>
            </ng-container>

            <!-- DOCTOR Column -->
            <ng-container matColumnDef="doctor">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell></td>
              <td mat-cell *matCellDef="let order">
                <mat-icon *ngIf="order.doctorNameSurname != null" class="doctor-icon ml-3" svgIcon="doctor"
                  [matTooltip]="order.doctorNameSurname"></mat-icon>
              </td>
            </ng-container>

            <!-- urgent column -->
            <ng-container matColumnDef="warning">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let order">
                <mat-icon *ngIf="order.ysnCriticalAlarm == -1" aria-hidden="false" class="alert-icon"
                aria-label="alert icon" matTooltip="Resultados fuera de los valores de referencia">error_outline
              </mat-icon>
              </td>
            </ng-container>

            <!-- Title Column -->
            <ng-container matColumnDef="orderDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha</th>
              <td mat-cell *matCellDef="let order">{{order.orderDate}}</td>
            </ng-container>

            <!-- State Column -->
            <ng-container matColumnDef="patientName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Paciente</th>
              <td mat-cell *matCellDef="let order">{{ order.patientName }}</td>
              <!--+" "+(order.patientSex =="F" ? "♀":"♂") }}-->
            </ng-container>

            <!-- State Column -->
            <ng-container matColumnDef="sex">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let order">
                <span [class.icon-male]="order.patientSex =='M'" [class.icon-female]="order.patientSex =='F'"
                  [class.icon-neutral]="order.patientSex !='F' && order.patientSex !='M'"></span>
              </td>
              <!--+" "+(order.patientSex =="F" ? "♀":"♂") }}-->
            </ng-container>

            <!-- State Column -->
            <ng-container matColumnDef="service">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Servicio</th>
              <td mat-cell *matCellDef="let order">{{ order.service }}</td>
            </ng-container>

            <ng-container matColumnDef="stateDescription">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let order">{{stateDescription(order) }}</td>
            </ng-container>

            <!-- State Column -->
            <ng-container matColumnDef="report">
              <th mat-header-cell *matHeaderCellDef>
                <button mat-icon-button [class.filter-reports]="withReports" (click)="filterWithReport(patient)"
                [disabled]="!orderWithReports">
                <mat-icon aria-hidden="false" aria-label="report icon">description</mat-icon>
              </button>
              </th>
              <td mat-cell *matCellDef="let order">
                <button mat-icon-button (click)="viewReport(order); $event.stopPropagation()"
                  [color]="order.reportState >= 2 ? env.color_report_complete:env.color_report_partial" [disabled]="order.reportState == 0"
                  [matTooltip]="order.reportState >= 2 ? 'Informe final':'Informe parcial'">
                  <mat-icon aria-hidden="false" aria-label="print icon">description</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="results">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let order">
                <button mat-icon-button *ngIf="group.gridResult"
                  (click)="viewResults(order); $event.stopPropagation()">
                  <mat-icon aria-hidden="false" aria-label="view results icon">view_list</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="info">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let order">
                <button mat-icon-button (click)="viewInfo(order); $event.stopPropagation()">
                  <mat-icon aria-hidden="false" aria-label="view info icon">info</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row
              *matHeaderRowDef="['select', 'orderDate', 'doctor' ,'warning', 'orderId', 'service', 'stateDescription' ,  'results','report', 'info' ]">
            </tr>
            <tr mat-row
              *matRowDef="let order; columns: ['select', 'orderDate','doctor','warning', 'orderId', 'service', 'stateDescription',  'results','report', 'info' ];"
              (click)="selectOrder(order)" [class.selected]="order.selected"></tr>
          </table>
          <mat-paginator class="paginator-orders" #patientOrdersPaginator [pageSizeOptions]="[10, 20, 50]"
            showFirstLastButtons></mat-paginator>

        </mat-expansion-panel>
      </mat-accordion>

    </div>

  </div>



  <!-- FIN CONTENEDOR -->
</div>